import { X } from "lucide-react"
import './wishlist.scss'
import { useEffect, useState } from "react"
import SkeletonLoader from "../SkeletonLoaders/DefaultLoader"
import { addToCartAPi, deleteFromWishlist, loadWishlist } from "../../api/requests"
import { useNotification } from "../../context/NotificationContext"
import EmptyDisplay from "../EmptyDisplay/EmptyDisplay"
import { Wishlist as WishlistProp } from "../../interface/interfaces"
import LoaderBtn from "../LoaderBtn/LoaderBtn"
import { useCart } from "../../context/CartContext"
import 'animate.css'

const Wishlist = () => {
    const { syncCart } = useCart()

    type WishListObj = {
        items: WishlistProp[],
        isLoading: boolean
    }


    const { notify } = useNotification()

    const [wishListData, setWishListData] = useState<WishListObj>({
        items: [],
        isLoading: false
    })


    const setLoader = ((value: boolean) => {
        setWishListData((prev) => { return { ...prev, isLoading: value } })
    })

    const setAddLoader = (wishlist_id: string, value: boolean) => {
        setWishListData((prev: any) => {
            const newArr = prev.items.map((eachObj: any) => ({
                ...eachObj,
                addLoader: eachObj.id === wishlist_id ? value : false,
            }));

            return {
                ...prev,
                items: newArr,
            };
        });
    };


    const setDeleteLoader = (wishlist_id: string, value: boolean) => {
        setWishListData((prev: any) => {
            const newArr = prev.items.map((eachObj: any) => ({
                ...eachObj,
                deleteLoader: eachObj.id === wishlist_id ? value : false,
            }));

            return {
                ...prev,
                items: newArr,
            };
        });
    }

    useEffect(() => {

        const func = async () => {
            try {
                setLoader(true)
                let resp = await loadWishlist(1, 100)

                setWishListData((prev) => {
                    return {
                        ...prev,
                        items: resp.wishlist
                    }
                })

            } catch (error: any) {
                notify.error(error.message)
            } finally {
                setLoader(false)
            }
        }

        func()
        // eslint-disable-next-line
    }, [])



    // const loadData = async () => {
    //     try {

    //         let resp = await loadWishlist(1, 100)

    //         setWishListData((prev) => {
    //             return {
    //                 ...prev,
    //                 items: resp.wishlist
    //             }
    //         })

    //     } catch (error: any) {
    //         notify.error(error.message)
    //     }
    // }



    const handleAddToCart = async (wishlist_id: string, product_id: string) => {
        try {

            setAddLoader(wishlist_id, true)

            let resp = await addToCartAPi(product_id, '', '', 1)
            // await loadData()

            if (resp) {

                await Promise.all([
                    deleteFromWishlist(wishlist_id),
                    syncCart(true)
                ]);
                

                setWishListData((prev) => {

                    let arr = prev.items.filter((data) => {
                        return data.id !== wishlist_id
                    })

                    return {
                        ...prev,
                        items: arr
                    }
                })

                notify.success('Added to cart!')
            }

        } catch (error:any) {
            notify.error(error.message)
        } finally {
            setAddLoader(wishlist_id, false)
        }

    }

    const handleDelete = async (wishlist_id: string) => {
        try {

            setDeleteLoader(wishlist_id, true)

            let resp = await deleteFromWishlist(wishlist_id)
            setWishListData((prev) => {

                let arr = prev.items.filter((data) => {
                    return data.id !== wishlist_id
                })

                return {
                    ...prev,
                    items: arr
                }
            })

            if (resp) {
                notify.success('Deleted from wishlist!')
            }


        } catch (error) {
            notify.error('An error occured while deleting,please try again!')
        } finally {
            setDeleteLoader(wishlist_id, false)
        }
    }



    return (


        <div className='wishlist'>

            {wishListData.isLoading && (<SkeletonLoader count={4}></SkeletonLoader>)}

            {!wishListData.isLoading && (
                <div className="animate__animated animate__fadeIn animate__fast">

                {wishListData.items.length >= 1 && (<div className="wishlist-table">

                    <div className="wishlist-header">
                        <div className='eachH'>Products</div>
                        <div className='eachH'>Price</div>
                        <div className='eachH'>Stock Status</div>
                        <div className='eachH'></div>
                    </div>

                    {wishListData.items.map((data, index) => (
                        <div className="wishlist-item" key={index}>

                            <div className="product-info">

                                <div className='imageBox'>
                                    <img src={data.product_image[0]} className='image' alt='Product'></img>

                                    {/* <BoxIcon size={40} strokeWidth={1} color='var(--gray-one)'></BoxIcon> */}
                                </div>

                                <div className='textcontent'>

                                    <div className='productname'>{data.product_name}</div>

                                    <div className='props'>

                                    </div>

                                </div>

                            </div>

                            <div className='eachdata'>
                                <div className="price productprice">
                                    <span>₦{(data.product_price).toLocaleString()}</span>
                                </div>
                            </div>


                            <div className='eachdata'>
                                <div className='orderstatus green'>In stock</div>
                            </div>


                            <div className='eachdata deletesection'>


                                <LoaderBtn className={"btn full"} text={"Add to Cart"} clickFunction={() => handleAddToCart(data.id, data.product_id)} isLoading={data.addLoader}></LoaderBtn>


                                <div className='deletebtn' onClick={() => handleDelete(data.id)}>
                                    {!data.deleteLoader && (<X size={16}></X>)}
                                    {data.deleteLoader && (<div className='smallspinner'></div>)}
                                </div>

                            </div>

                        </div>

                    ))}





                    {/* 
                    <div className="wishlist-item">

                        <div className="product-info">

                            <div className='imageBox'>
                             
                                <BoxIcon size={40} strokeWidth={1} color='var(--gray-one)'></BoxIcon>
                            </div>

                            <div className='textcontent'>

                                <div className='productname'>Product Name</div>

                                <div className='props'>
                                 
                                    <div className='eachprop'>
                                        <span className='proptitle'>Size:</span>
                                        <RenderCartProp type={'size'} value={'41'}></RenderCartProp>
                                    </div>
                                   
                                </div>

                            </div>

                        </div>

                        <div className='eachdata'>
                            <div className="price productprice">
                               
                                <span>$25,000</span>
                            </div>
                        </div>


                        <div className='eachdata'>
                            <div className='orderstatus red'>Out of stock</div>
                        </div>


                        <div className='eachdata deletesection'>

                            <button className="btn full disabled" disabled={true}>Add to Cart</button>

                            <div className='deletebtn'>
                                <X size={16}></X>
                            </div>

                        </div>

                    </div> */}



                </div>)}


                {(wishListData.items.length < 1) && (
                    <EmptyDisplay text="No new products on wishlist!" icon_class="wishlist" ></EmptyDisplay>
                )}


            </div>
            )}

        </div>)
}


export default Wishlist